import { useMutation } from "@tanstack/react-query";

import { displayErrorToast } from "@/utils/toast";

export interface AIDatasetAssistantParams {
  description: string;
  prompt_template: string;
  row_schema?: object | null;
}

export interface AIDatasetAssistantResponse {
  variables: Record<string, string>;
}

export const useAIDatasetAssistant = () =>
  useMutation<AIDatasetAssistantResponse, Error, AIDatasetAssistantParams>(
    async ({ description, prompt_template, row_schema }) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        displayErrorToast(
          "Oh no! The AI dataset assistant is taking too long to respond. Please try again.",
        );
      }, 35000);

      try {
        const response = await fetch("https://hook.us1.make.com/yeqk2o9ehl7u7588upfcn5du3togu8ue", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            description,
            prompt_template,
            ...(row_schema !== null && { row_schema }),
          }),
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.generation_error) {
          displayErrorToast(data.generation_error);
          throw new Error(data.generation_error);
        }

        // The API returns { row: { variable1: value1, variable2: value2, ... } }
        return { variables: data.row || data.variables || data };
      } finally {
        clearTimeout(timeoutId);
      }
    },
  );
